<template>
  <div>
    <vx-card>
      <ListContratos :subjectPermission="subjectPermission"></ListContratos>
    </vx-card>
  </div>
</template>

<script>
import ListContratos from "./../../lists/ListContratos";

export default {
  data() {
    return {
      subjectPermission: "Contrato",
    };
  },
  methods: {},
  components: {
    ListContratos,
  },
};
</script>
